/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clubs_Empty_Invite_TitleInputs */

const en_us2_clubs_empty_invite_title = /** @type {(inputs: Clubs_Empty_Invite_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invite someone you train with`)
};

const pt_br2_clubs_empty_invite_title = /** @type {(inputs: Clubs_Empty_Invite_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convide quem treina com você`)
};

const es_419_clubs_empty_invite_title = /** @type {(inputs: Clubs_Empty_Invite_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invita a alguien con quien entrenas`)
};

const pt_pt2_clubs_empty_invite_title = /** @type {(inputs: Clubs_Empty_Invite_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convida quem treina contigo`)
};

const fr_fr2_clubs_empty_invite_title = /** @type {(inputs: Clubs_Empty_Invite_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invite quelqu'un avec qui tu t'entraînes`)
};

const de_de2_clubs_empty_invite_title = /** @type {(inputs: Clubs_Empty_Invite_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lade jemanden ein, mit dem du trainierst`)
};

const it_it2_clubs_empty_invite_title = /** @type {(inputs: Clubs_Empty_Invite_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invita qualcuno con cui ti alleni`)
};

/**
* | output |
* | --- |
* | "Invite someone you train with" |
*
* @param {Clubs_Empty_Invite_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_empty_invite_title = /** @type {((inputs?: Clubs_Empty_Invite_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_Empty_Invite_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_empty_invite_title(inputs)
	if (locale === "es-419") return es_419_clubs_empty_invite_title(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_empty_invite_title(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_empty_invite_title(inputs)
	if (locale === "de-DE") return de_de2_clubs_empty_invite_title(inputs)
	if (locale === "it-IT") return it_it2_clubs_empty_invite_title(inputs)
	return en_us2_clubs_empty_invite_title(inputs)
});
export { clubs_empty_invite_title as "clubs.empty_invite_title" }